// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  background-color: var(--dark-grey);
  border: 1px solid var(--border-color);
  border-radius: var(--tiny-border-radius);
  padding: calc(var(--tooltip-padding) / 4) var(--tooltip-padding);
  font-size: var(--font-size-m);
  color: var(--text-contrast-color);
  opacity: 0.95;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/html-tooltip/HTMLTooltip.component.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,wCAAwC;EACxC,gEAAgE;EAChE,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;AACf","sourcesContent":[".tooltip-container {\n  background-color: var(--dark-grey);\n  border: 1px solid var(--border-color);\n  border-radius: var(--tiny-border-radius);\n  padding: calc(var(--tooltip-padding) / 4) var(--tooltip-padding);\n  font-size: var(--font-size-m);\n  color: var(--text-contrast-color);\n  opacity: 0.95;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
